import { render, staticRenderFns } from "./PurchasesSpendStars.vue?vue&type=template&id=66615d82"
import script from "./PurchasesSpendStars.vue?vue&type=script&lang=js"
export * from "./PurchasesSpendStars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports